<div class="internal-chat-body" [ngSwitch]="route">
  <internal-users-list *ngSwitchCase="_routes.USERS_LIST"></internal-users-list>
  <internal-users-list *ngSwitchCase="_routes.CREATE_CHAT"></internal-users-list>
  <internal-chats-list *ngSwitchCase="_routes.CHATS_LIST"></internal-chats-list>
  <internal-chat-history *ngSwitchCase="_routes.CHAT"></internal-chat-history>
</div>
